import { Box, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { numericFormatter } from "react-number-format";
import { ISalesDeal } from "../../Interfaces";

export const salesHistoryColumns = (): GridColDef[] => {
  return [
    {
      field: "dealDescription",
      headerName: "Deal Description",
      editable: false,
      width: 500,
      sortable: false,
    },
    {
      field: "dealStage",
      headerName: "Deal Stage",
      editable: false,
      width: 250,
      sortable: false,
    },
    {
      field: "valueOfTesting",
      headerName: "Value of testing",
      editable: false,
      width: 120,
      sortable: false,
      valueFormatter(params) {
        return numericFormatter(`${params.value}`, {
          thousandSeparator: true,
          decimalScale: 2,
          fixedDecimalScale: true,
          prefix: "$",
        });
      },
    },
    {
      field: "valueOfTraining",
      headerName: "Value of training",
      editable: false,
      width: 120,
      sortable: false,
      valueFormatter(params) {
        return numericFormatter(`${params.value}`, {
          thousandSeparator: true,
          decimalScale: 2,
          fixedDecimalScale: true,
          prefix: "$",
        });
      },
    },
    {
      field: "valueOfPolicyReview",
      headerName: "Value of policy",
      editable: false,
      width: 120,
      sortable: false,
      valueFormatter(params) {
        return numericFormatter(`${params.value}`, {
          thousandSeparator: true,
          decimalScale: 2,
          fixedDecimalScale: true,
          prefix: "$",
        });
      },
    },
    {
      field: "valueOfHealthTickServices",
      headerName: "Health tick",
      editable: false,
      width: 120,
      sortable: false,
      valueFormatter(params) {
        return numericFormatter(`${params.value}`, {
          thousandSeparator: true,
          decimalScale: 2,
          fixedDecimalScale: true,
          prefix: "$",
        });
      },
    },
    {
      field: "totalValue",
      headerName: "Total",
      editable: false,
      width: 120,
      sortable: false,
      valueFormatter(params) {
        return numericFormatter(`${params.value}`, {
          thousandSeparator: true,
          decimalScale: 2,
          fixedDecimalScale: true,
          prefix: "$",
        });
      },
    },
    {
      field: "closureComment",
      headerName: "Closure Comment",
      editable: false,
      width: 300,
      sortable: false,
    },
    {
      field: "lastModifiedBy",
      headerName: "Modified By/On",
      editable: false,
      width: 200,
      sortable: false,
      renderCell: (params): any => {
        let row = params.row as ISalesDeal;
        return (
          <Box>
            <Box>{row.updatedBy}</Box>
            <Box>{row.updatedOn}</Box>
          </Box>
        );
      },
    },
  ];
};
